import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import throttle from 'transmute/throttle';
import useCollaborationSidebarProps from '../../hooks/useCollaborationSidebarProps';
import useCollaborationSidebarState from '../../hooks/useCollaborationSidebarState';
import { useDeepCommentingNavigationMessaging, useSidebarMessageHandlers, useTaskMessaging } from '../messaging/messageHandlers';
export const SidebarMessageHandler = () => {
  "use memo";

  const $ = _c(30);
  const {
    onUpdateCollaborationSidebarState,
    collaborationSidebarState
  } = useCollaborationSidebarState();
  const {
    isOpen: currentIsOpen,
    tab: currentTab
  } = collaborationSidebarState;
  const {
    onScrollToModule,
    onHighLightModuleChange,
    embeddedCommentsProps,
    onTaskOpened
  } = useCollaborationSidebarProps();
  let t0;
  if ($[0] !== onUpdateCollaborationSidebarState) {
    t0 = throttle(200, t1 => {
      const {
        isOpen,
        tab
      } = t1;
      return onUpdateCollaborationSidebarState({
        isOpen,
        tab
      });
    });
    $[0] = onUpdateCollaborationSidebarState;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const throttledOpenSidebarWithTab = t0;
  let t1;
  if ($[2] !== onUpdateCollaborationSidebarState) {
    t1 = throttle(200, () => onUpdateCollaborationSidebarState({
      isOpen: false
    }));
    $[2] = onUpdateCollaborationSidebarState;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const throttledCloseSidebar = t1;
  let t2;
  if ($[4] !== onUpdateCollaborationSidebarState) {
    t2 = throttle(200, tab_0 => onUpdateCollaborationSidebarState({
      tab: tab_0
    }));
    $[4] = onUpdateCollaborationSidebarState;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const throttledUpdateSidebarTab = t2;
  let t3;
  if ($[6] !== currentIsOpen || $[7] !== currentTab || $[8] !== throttledOpenSidebarWithTab) {
    t3 = t4 => {
      const {
        tab: tab_1
      } = t4;
      if (currentIsOpen && tab_1 === currentTab) {
        return;
      }
      throttledOpenSidebarWithTab({
        isOpen: true,
        tab: tab_1
      });
    };
    $[6] = currentIsOpen;
    $[7] = currentTab;
    $[8] = throttledOpenSidebarWithTab;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== currentIsOpen || $[11] !== throttledCloseSidebar) {
    t4 = () => {
      if (!currentIsOpen) {
        return;
      }
      throttledCloseSidebar();
    };
    $[10] = currentIsOpen;
    $[11] = throttledCloseSidebar;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== currentTab || $[14] !== throttledUpdateSidebarTab) {
    t5 = t6 => {
      const {
        tab: tab_2
      } = t6;
      if (currentTab === tab_2) {
        return;
      }
      throttledUpdateSidebarTab(tab_2);
    };
    $[13] = currentTab;
    $[14] = throttledUpdateSidebarTab;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t5) {
    t6 = {
      onRequestOpenSidebar: t3,
      onRequestCloseSidebar: t4,
      onRequestChangeSidebarTab: t5
    };
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  useSidebarMessageHandlers(t6);
  let t7;
  if ($[20] !== embeddedCommentsProps || $[21] !== onScrollToModule) {
    t7 = msg => {
      onScrollToModule === null || onScrollToModule === void 0 || onScrollToModule(msg.payload.moduleId);
      if (msg.payload.location) {
        var _embeddedCommentsProp;
        embeddedCommentsProps === null || embeddedCommentsProps === void 0 || (_embeddedCommentsProp = embeddedCommentsProps.indicatorNavigateTo) === null || _embeddedCommentsProp === void 0 || _embeddedCommentsProp.call(embeddedCommentsProps, msg.payload.location, msg.payload.moduleId);
      }
    };
    $[20] = embeddedCommentsProps;
    $[21] = onScrollToModule;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== onHighLightModuleChange) {
    t8 = msg_0 => {
      onHighLightModuleChange === null || onHighLightModuleChange === void 0 || onHighLightModuleChange(msg_0.payload.moduleId);
    };
    $[23] = onHighLightModuleChange;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== t7 || $[26] !== t8) {
    t9 = {
      onRequestScrollToModule: t7,
      onRequestHighlightModule: t8
    };
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  useDeepCommentingNavigationMessaging(t9);
  let t10;
  if ($[28] !== onTaskOpened) {
    t10 = {
      onTaskOpened: msg_1 => {
        onTaskOpened === null || onTaskOpened === void 0 || onTaskOpened({
          marketingStudioNodeId: msg_1.payload.marketingStudioNodeId,
          taskId: msg_1.payload.taskId
        });
      }
    };
    $[28] = onTaskOpened;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  useTaskMessaging(t10);
  return null;
};